import(/* webpackMode: "eager", webpackExports: ["AcquisitionAnnouncementHomepage"] */ "/usr/src/app/components/pages/acquisition-announcement-homepage.tsx");
